/** Carga única de Google Maps JavaScript API (sin loading=async+callback, que rompe la init). */

let loadPromise = null;

function installAuthFailureHook() {
  if (typeof window === "undefined" || window.__vitalcasaGmapsAuthHook) return;
  window.__vitalcasaGmapsAuthHook = true;
  window.gm_authFailure = () => {
    window.__vitalcasaGmapsAuthFail = true;
    window.dispatchEvent(new CustomEvent("vitalcasa-gmaps-auth-failure"));
  };
}

export function resetGoogleMapsLoader() {
  loadPromise = null;
}

export function loadGoogleMapsJs(apiKey) {
  if (typeof window === "undefined") {
    return Promise.reject(new Error("no_window"));
  }
  if (window.__vitalcasaGmapsAuthFail) {
    return Promise.reject(new Error("maps_auth_failed"));
  }
  if (window.google?.maps?.Map) {
    return Promise.resolve(window.google.maps);
  }

  const key = String(apiKey || "").trim();
  if (!key) return Promise.reject(new Error("no_key"));

  installAuthFailureHook();

  if (!loadPromise) {
    loadPromise = new Promise((resolve, reject) => {
      const cbName = `__vitalcasaGmapsCb_${Date.now()}`;
      const timeout = setTimeout(() => {
        loadPromise = null;
        reject(new Error("maps_timeout"));
      }, 20000);

      window[cbName] = () => {
        clearTimeout(timeout);
        try {
          delete window[cbName];
        } catch {
          /* ignore */
        }
        if (window.__vitalcasaGmapsAuthFail) {
          loadPromise = null;
          reject(new Error("maps_auth_failed"));
          return;
        }
        if (window.google?.maps?.Map) resolve(window.google.maps);
        else {
          loadPromise = null;
          reject(new Error("maps_unavailable"));
        }
      };

      const script = document.createElement("script");
      script.async = true;
      script.defer = true;
      script.src =
        `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(key)}` +
        `&language=es&region=ES&callback=${cbName}`;
      script.onerror = () => {
        clearTimeout(timeout);
        loadPromise = null;
        reject(new Error("maps_script_failed"));
      };
      document.head.appendChild(script);
    });
  }
  return loadPromise;
}
